import n from "./highrise1337.mjs";
function s(u, h) {
  return function(r, a) {
    if (r == null)
      return r;
    if (!n(r))
      return u(r, a);
    for (var t = r.length, e = -1, f = Object(r); ++e < t && a(f[e], e, f) !== !1; )
      ;
    return r;
  };
}
export {
  s as default
};
